import { Settings } from '@/types';
const state = {
    general: new Settings({})
};
export default state;
